export enum PaymentStep {
  COUPON_CODE = 'coupon_code',
  PAY_VIA_CARD = 'pay_via_card',
  PAYMENT_SUCCESS = 'payment_success',
  PAYMENT_FAILED = 'payment_failed',
}
